import { projectToCRS } from "@nova/calculate-geospatial"
import { FeatureCollection } from "geojson"
import { Icon } from "@nova/protobuf"
export const iconTransformer = (icons: Icon[], projection?: string) => {
    const json = { type: "FeatureCollection", features: [] } as FeatureCollection
    icons.forEach((icon) => {
        json.features.push({
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: projectToCRS([icon.longitude, icon.latitude], projection),
            },
            properties: {
                id: icon.id,
                name: icon.name,
                url: icon.url,
                color: icon.color,
            },
        })
    })
    return json
}
